import { useState } from 'react';
import FontBody1 from '../../../fonts/font-body1/font-body1';
import { IconProps } from '../../../icons/icon-props-interface';
import Icon from '../../../icons/icon/icon';
import './tab-label.scss';
import { FONT_COLOR } from '../../../fonts/font-props';
import { TABS_SIZE_VARIANTS } from '../../tabs';
import FontBody2 from '../../../fonts/font-body2/font-body2';

export interface ITabLabelProps {
    label: string;
    disabled?: boolean;
    onClick?: () => void;
    icon?: React.FC<IconProps>;
}

const getFontComponent = (sizeVariant?: TABS_SIZE_VARIANTS) => {
    switch (sizeVariant) {
        case TABS_SIZE_VARIANTS.SMALL:
            return FontBody2;
        default:
            return FontBody1;
    }
}

interface IProps extends ITabLabelProps {
    isActive: boolean;
    variant?: TABS_SIZE_VARIANTS;
}
const TabLabel: React.FC<IProps> = ({ label, isActive, disabled, onClick, icon, variant }) => {
    const [isFocused, setIsFocused] = useState(false);
    const iconColor = isActive || isFocused ? 'var(--color-primary-1)' : 'var(--color-primary-3-50)';
    const fontColor = isActive || isFocused ? FONT_COLOR.PRIMARY1 : FONT_COLOR.PRIMARY3_50;
    const FontComponent = getFontComponent(variant);

    return (
        <div
            role='tab'
            onMouseOut={() => setIsFocused(false)}
            onMouseOver={() => setIsFocused(true)}
            onClick={onClick}
            className={`tab-label${isActive ? ' active' : ''} ${disabled ? 'disabled' : ''}`}
        >
            {icon && <Icon Component={icon}
                color={iconColor}
                disabled={disabled}
            />}
            <FontComponent color={fontColor}>{label}</FontComponent>
            {isActive && <div className='tab-label-active-indicator'></div>}
        </div>
    );
}

export default TabLabel;